import { Row } from "@tanstack/react-table";
import { TableCell, TableRow } from "@mui/material";
import { twMerge } from "tailwind-merge";

import { DraggableTableRow } from "ui/data-grid/components/draggable-table-row/draggable-table-row";
import { DragHandleCell } from "ui/data-grid/components/drag-handle-cell/drag-handle-cell";
import { TableBodyCell } from "ui/data-grid/components/table-view/table-body-cell";

import { splitCellsByPin } from "ui/data-grid/helpers/split-cells-by-pin";
import { resolveDraggableRowId } from "ui/data-grid/helpers/resolve-draggable-row-id";

type TableDataRowProps<T> = {
  row: Row<T>;
  isDraggable: boolean;
  draggableId?: string;
  tableId?: string;
  renderSpacer: boolean;
  rowClassName?: string;
  cellClassName?: string;
};

export const TableDataRow = <T,>({
  row,
  isDraggable,
  draggableId,
  tableId,
  renderSpacer,
  rowClassName,
  cellClassName,
}: TableDataRowProps<T>) => {
  const { leftCells, rightCells } = splitCellsByPin(row.getVisibleCells());

  const cells = (
    <>
      {leftCells.map((cell) => (
        <TableBodyCell key={cell.id} cell={cell} cellClassName={cellClassName} />
      ))}

      {renderSpacer && <TableCell />}

      {rightCells.map((cell) => (
        <TableBodyCell key={cell.id} cell={cell} cellClassName={cellClassName} />
      ))}
    </>
  );

  if (isDraggable && draggableId && tableId) {
    const rowId = resolveDraggableRowId(row, draggableId);

    return (
      <DraggableTableRow
        id={rowId}
        tableId={tableId}
        className={twMerge("bg-white hover:bg-gray-50", rowClassName)}>
        <TableCell className="w-8 p-0">
          <DragHandleCell rowId={rowId} tableId={tableId} />
        </TableCell>

        {cells}
      </DraggableTableRow>
    );
  }

  return <TableRow className={twMerge("bg-white hover:bg-gray-50", rowClassName)}>{cells}</TableRow>;
};
